import React, { memo } from "react";

import InfoHeader from "./InfoHeader";
import MainHeader from "./MainHeader";

const DesktopHeader = () => {
  return (
    <React.Fragment>
      <InfoHeader />
      <MainHeader />
    </React.Fragment>
  );
};
export default memo(DesktopHeader);
